import { createAction } from 'typesafe-actions';

import type { ModalPayload } from 'src/modules/ConfirmModal/types.ts';

export const open = createAction('open')<ModalPayload>();

export const run = createAction('run')();
export const close = createAction('close')();
